module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3MPCSr/tc-custom/9781400217595.jpg?1703909327317",
      "alt": "This image is the cover for the book 100 Favorite Bible Prayers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("100 Favorite Bible Prayers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("With prayers for healing, peace, and strength for today, "), _c('i', [_vm._v("100 Favorite Bible Prayers ")]), _vm._v("invites you to rest in God's presence as you develop the practice of praying through the great prayers of the Bible.")])]), _c('p', [_vm._v("Discover the life-changing power of conversation with God as you immerse yourself in the richest prayers of the Old and New Testaments"), _c('i', [_vm._v(". ")]), _vm._v("From Hannah's prayers for a child to Jesus' prayer in Gethsemane, the prayers of Scripture remind us of God's longing for us to draw near to Him. Inside this beautiful gift book, you’ll find:")]), _vm._v("Each prayer paired with a brief devotion to help you understand the Scripture context and learn how to apply the prayers in your own lifeFour-color botanical-themed illustrations and lovely typography lines on every page"), _c('p', [_c('i', [_vm._v("100 Favorite Bible Prayers ")]), _vm._v("will help women create the habit of praying Scripture. The prayers can be a great way start each day or a pleasant way to relax and spend quiet time with the Lord each evening. This is a gorgeous gift for birthdays, gift giving holidays, or for a friend wanting to grow deeper in his or her relationship with God.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stacy Edwards\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0